import { Divider as CoreDivider, PhoneNumberInput as CorePhoneNumberInput } from '@hopskipdrive/react-components';
import { variables } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
  gap: 36px;
  width: 100%;
  margin-bottom: 16px;

  /* Each inner Box (label + input pair) fills half the row */
  > .MuiBox-root {
    display: flex;
    align-items: center;
    gap: 24px;
    flex: 1;
    min-width: 0;
  }

  label {
    min-width: 101px;
    width: 101px;
    flex-shrink: 0;
    white-space: nowrap;
    text-align: left;
    margin: 0;
  }

  /* Inputs and selects fill remaining space */
  .MuiOutlinedInput-root {
    width: 100%;
  }

  .MuiAutocomplete-root {
    flex: 1;
    min-width: 0;
  }

  ${variables.mediaQuery.lessThan('desktop')`
    flex-direction: column;
    gap: 16px;

    > .MuiBox-root {
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
      width: 100%;
    }

    label {
      width: auto;
      min-width: auto;
    }

    .MuiOutlinedInput-root {
      width: 100%;
    }

    .MuiAutocomplete-root {
      width: 100%;
    }
  `}
`;

export const PhoneNumberInput = styled(CorePhoneNumberInput)`
  flex: 1;
  min-width: 0;

  ${variables.mediaQuery.lessThan('desktop')`
    width: 100%;
  `}
`;

export const Divider = styled(CoreDivider)`
  margin: 10px 0;
`;
